<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <div class="with-desc">
            <h2>{{translate?.general.buttons.clear.singular}} {{translate?.jobOrder.label.plural}}</h2>
        </div>
        <button class="icon-btn" aria-label="Close" [pTooltip]="translate?.general.buttons.close.singular"
            (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <div class="flx-modal__subheader">
        <h3>Select a date range to remove the scheduled jobs within it.</h3>
    </div>
    <div class="flx-modal__body">
        <div class="status-field">
            <div class="mp-row">
                <form [formGroup]="dateRangeForm" class="field-row--auto_range">
                    <div class="status-field">
                        <span class="field-label mandatory">{{translate?.planner.fields.startDate.singular}}</span>
                        <p-calendar formControlName="startDate" placeholder="dd/mm/yy" dateFormat="d/m/yy" [showIcon]="true" appendTo="body" styleClass="cal-btn"></p-calendar>
                        <div class="p-error text-10"
                            *ngIf="
                                (dateRangeForm.controls['startDate'].touched || dateRangeForm.controls['startDate'].dirty) &&
                                dateRangeForm.controls['startDate'].invalid
                            ">
                            <span *ngIf="dateRangeForm.controls['startDate'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                        </div>
                    </div>
                    <span class="divider-two"><i class="fa-solid fa-minus"></i></span>
                    <div class="status-field">
                        <span class="field-label mandatory">{{translate?.planner.fields.endDate.singular}}</span>
                        <p-calendar formControlName="endDate" placeholder="dd/mm/yy" dateFormat="d/m/yy" [showIcon]="true" appendTo="body" styleClass="cal-btn" [minDate]="minDateForEndDate"></p-calendar>
                        <div class="p-error text-10"
                            *ngIf="
                                (dateRangeForm.controls['endDate'].touched || dateRangeForm.controls['endDate'].dirty) &&
                                dateRangeForm.controls['endDate'].invalid
                            ">
                            <span *ngIf="dateRangeForm.controls['endDate'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div class="flx-modal__footer">
        <button type="button" class="custella-btn-white" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular }}</button>
        <p-button styleClass="h-32" type="button" [label]="translate?.general.buttons.clear.singular" (onClick)="onClearClick()"></p-button>
    </div>
</div>